<template>
<ValidationObserver class="col" tag="div" ref="form" v-slot="{ handleSubmit, invalid }">
    <Loading />
    <Message />

    <CForm method="post" @submit.prevent="handleSubmit(submit)">
        <CRow>
            <CCustomSelect
                sm="12" md="3"
                v-model="conversion.status"
                :options="conversionStatusOption"
                vid="status"
                required
                rules="required"
                :name="$t('conversion.status')"
            />
            <CCustomInput
                v-model="conversion.external_id"
                sm="12" md="4"
                vid="external_id"
                :name="$t('conversion.external_id')"
                rules="required"
                required
                ltr
            />
            <CCustomInput
                v-model="conversion.amount"
                sm="12" md="5"
                vid="amount"
                :name="$t('conversion.amount')"
                rules="required"
                type="number"
                required
                ltr
            />
        </CRow>

        <CButton :disabled="invalid" type="submit"  color="primary" class="px-4">{{ $t('submit') }}</CButton>
    </CForm>
</ValidationObserver>
</template>

<script>
import { conversionStatusOption } from '@/common/data'

export default {
    name: 'Form',

    props: {
        submit: {
            type: Function,
            default() {}
        },
        conversion: {
            default() {
                return {
                    external_id: '',
                    amount: '',
                    status: '',
                }
            },
            type: Object
        }
    },
    data() {
        return {
            conversionStatusOption
        }
    },
}
</script>